export class ReminderSettingsScheduleEntry {
  number_of_days_since_dispatch: number;

  constructor(v: Partial<ReminderSettingsScheduleEntry> = {}) {
    this.number_of_days_since_dispatch = v.number_of_days_since_dispatch;
  }
}
